module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back001sp.2bb170a0.webp";